import './styles.ddc.scss'

export default (WIAPI, startPlugin) => {
  const API = new WIAPI('com.max.sdk.vdp')
  API.subscribe('page-load-v1', function (ev) {
    if (ev.payload.searchPage || ev.payload.detailPage) {
      API.insert('vehicle-pricing', function (elem, meta) {
        const template = document.createElement('template')
        template.dataset.m4w = true
        template.dataset.inventory = meta.vin
        API.append(elem, template)
        startPlugin()
      })
    }
  })
}
